<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="solicitacaoCancelamento; else carregando">

    <div class="row">
        <div class="col">
            <h3>Detalhes da solicitação <small class="text-muted">(#ID: {{solicitacaoCancelamento?.id}})</small></h3>
        </div>
        <div class="col-auto">
            <button class="btn btn-primary" type="button" (click)="voltarParaLista ()">Voltar</button>
            <button *ngIf="podeAprovarOuReprovar" [disabled]="solicitacaoCancelamento?.estado?.id != 2"
                class="btn btn-light" type="button" (click)="executarAcao('aprovar')">Aprovar</button>
            <button *ngIf="podeAprovarOuReprovar" [disabled]="solicitacaoCancelamento?.estado?.id != 2"
                class="btn btn-light" type="button" (click)="executarAcao('reprovar')">Reprovar</button>
            <button *ngIf="podeAprovarOuReprovar" [disabled]="solicitacaoCancelamento?.estado?.id != 7"
                class="btn btn-light" type="button" (click)="executarAcao('reverter')">Reverter cancelamento</button>
        </div>
    </div>

    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="col nav-tabs">
    
        <li title="Solicitação de cancelamento" [ngbNavItem]>
          <a ngbNavLink>Solicitação de cancelamento</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div [ngClass]="'bn-form-group ' + (solicitacaoCancelamento.sistemaRepasse ? 'col-md-4' : 'col-md-6')">
                        <label><b>Agente financeiro</b></label>
                        <input type="text" class="form-control" name="nomeAgenteFinanceiro"
                            value="{{nomeAgente(solicitacaoCancelamento.cnpjAgenteFinanceiro)}}" disabled />
                    </div>
                    <div [ngClass]="'bn-form-group ' + (solicitacaoCancelamento.sistemaRepasse ? 'col-md-3' : 'col-md-6')"
                        *ngIf="solicitacaoCancelamento.idOperacaoExterno">
                        <label><b>Id. operação agente</b></label>
                        <input type="text" class="form-control" name="idOperacaoAgente"
                            value="{{solicitacaoCancelamento.idOperacaoExterno}}" disabled />
                    </div>
                    <div class="bn-form-group col-md-2" *ngIf="solicitacaoCancelamento.sistemaRepasse">
                        <label><b>Sistema</b></label>
                        <input type="text" class="form-control" value="{{solicitacaoCancelamento.sistemaRepasse}}"
                            disabled />
                    </div>
                    <div class="bn-form-group col-md-3" *ngIf="solicitacaoCancelamento.contratoRepasse">
                        <label><b>Contrato</b></label>
                        <div class="input-group">
                            <input type="text" class="form-control" [value]="solicitacaoCancelamento.contratoRepasse"
                                disabled />
                            <div
                                *ngIf="permissaoLinkN03 && solicitacaoCancelamento.contratoRepasse">
                                <span class="input-group-text"><a
                                        href="/n03_spa/#!/amb-ope/subcredito/documento-nivel/numero/{{solicitacaoCancelamento.contratoRepasse}}"><i
                                            class="fa fa-external-link-alt" ngbTooltip="Acessar Operação"></i></a></span>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="bn-form-group col-md-12">
                        <label><b>Motivo do cancelamento</b></label>
                        <input type="text" class="form-control" name="motivoCancelamento"
                            value="{{ obterDescricaoMotivoCancelamento(solicitacaoCancelamento)}}" disabled />
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-4">
                        <label><b>Valor honrado a recuperar atualizado</b>  <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                ngbTooltip="O valor honrado a recuperar (atualizado até a data de aprovação). Este será o valor de indenização cobrado."></i>
                        </label>
                        <input type="text" class="form-control" name="valorBaseCalculoMulta"
                            value="{{ solicitacaoCancelamento.saldoFgiNaDataAprovacaoCancelamento | bnMask:'MOEDA'}}"
                            disabled /> 
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label><b>Base de cálculo da multa</b>  <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                ngbTooltip="O valor sobre o qual incidirá a multa (caso haja). Este valor será sempre igual ao valor honrado a recuperar ou ao valor histórico da honra."></i>
                        </label>
                        <input type="text" class="form-control" name="valorBaseCalculoMulta"
                            value="{{ solicitacaoCancelamento.valorBaseCalculoMulta | bnMask:'MOEDA'}}"
                            disabled /> 
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label><b>Percentual de multa (%)</b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                            ngbTooltip="O valor percentual de multa a ser aplicado sobre a base de cálculo da multa. Se for zero, então não há cobrança de multa."></i>
                        </label>
                        <input type="text" class="form-control" name="valorPercentualMulta"
                            value="{{ solicitacaoCancelamento.valorPercentualMulta | bnMask:'DECIMAL': '6'}}"
                            disabled />
                    </div>
                </div>

                <div class="row">
                    <div class="bn-form-group col-md-4">
                        <label><b>Estado</b></label>
                        <input type="text" class="form-control" name="nomeEstado"
                            value="{{solicitacaoCancelamento.estado.nomeEstado}}" disabled />
                    </div>
                    <div class="bn-form-group col-md-8">
                        <label><b>Motivo da transição de estado</b></label>
                        <input type="text" class="form-control" name="motivoEstado"
                            value="{{solicitacaoCancelamento.estado.motivoEstado}}" disabled />
                    </div>
    
                </div>
    
                <div class="row">
                    <div class="bn-form-group col-md-4">
                        <label><b>Data de envio</b></label>
                        <bn-datepicker idInput="dataEnvio" name="dataEnvio" [(ngModel)]="solicitacaoCancelamento.dataEnvio" disabled>
                        </bn-datepicker>
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label><b>Data de aprovação</b></label>
                        <bn-datepicker idInput="dataAprovacao" name="dataAprovacao" [(ngModel)]="solicitacaoCancelamento.dataAprovacaoCancelamento"
                            disabled>
                        </bn-datepicker>
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label><b>Id. cobrança</b></label>
                        <div class="input-group">
                            <input type="text" class="form-control" name="idCobranca"
                                value="{{solicitacaoCancelamento?.identificadorCobranca}}" disabled />
                            <span class="input-group-text" *ngIf="solicitacaoCancelamento?.identificadorCobranca">
                                <a href="#/cobrancas/{{solicitacaoCancelamento?.identificadorCobranca}}">
                                    <i class="fa fa-external-link-alt"ngbTooltip="Ver detalhes da cobrança"></i>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="bn-form-group col-md-12">
                        <label for="comentarioSolicitante"><b>Comentários do solicitante</b></label>
                        <textarea class="form-control" name="comentarioSolicitante" id="comentarioSolicitante"
                            rows="6" [(ngModel)]="solicitacaoCancelamento.comentarioSolicitante" disabled>
                </textarea>
                    </div>
                </div>
    
            </ng-template>
        </li>
    
    
        <li title="Histórico" *ngIf="solicitacaoCancelamento.historicoEstados?.length > 0" [ngbNavItem]>
          <a ngbNavLink>Histórico</a>
            <ng-template ngbNavContent>
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col">Data</th>
                                <th scope="col">Estado</th>
                                <th scope="col">Motivo</th>
                                <th scope="col">Responsável</th>
                            <tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let hist of solicitacaoCancelamento.historicoEstados">
                                <td>{{ hist.dataUltimaAtualizacao | date:'dd/MM/yyyy H:mm'}}</td>
                                <td>{{ hist.estado.nomeEstado }}</td>
                                <td>{{ hist.estado.motivoEstado}}</td>
                                <td>{{ hist.nomeUsuarioResponsavel}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </li>
    
    </ul>
    <div [ngbNavOutlet]="nav"></div>
    </div>

<ng-template #aprovacao>
    <div class="row mb-2">

        <div class="col-md-9 mb-2">
            <label><b>Agente financeiro</b></label>
            <input type="text" class="form-control" name="nomeAgenteFinanceiro"
                value="{{nomeAgente(solicitacaoCancelamento.cnpjAgenteFinanceiro)}}" disabled />
        </div>
        <div class="col-md-3">
            <label><b>{{ solicitacaoCancelamento.idOperacaoExterno ? 'Id. operação agente' : 'Contrato Repasse' }}</b></label>
            <input type="text" class="form-control" name="idOperacaoAgente"
                value="{{solicitacaoCancelamento.idOperacaoExterno ? solicitacaoCancelamento.idOperacaoExterno : solicitacaoCancelamento.contratoRepasse}}" disabled />
        </div>
        <div class="col-md-3">
            <label><b>Val. hist. honra</b></label>     
            <input type="text" class="form-control" name="valorHistoricoHonra" [(ngModel)]="valorHistoricoHonra" bnMask="MOEDA" disabled/>
            <input type="radio" name="radioBaseCalculo" value="valorHistoricoHonra" [(ngModel)]="radioBaseCalculo" (change)="trocaOpcaoBaseMulta($event)" />
        </div>
        <div class="col-md-3">
            <label><b>Val. honrado a recuperar</b></label>               
            <input type="text" class="form-control" name="percentual" [(ngModel)]="valorHonradoARecuperar" bnMask="MOEDA" disabled/>
            <input type="radio" name="radioBaseCalculo" value="valorHonradoARecuperar" [(ngModel)]="radioBaseCalculo" (change)="trocaOpcaoBaseMulta($event)" />   
        </div>
        <div class="col-md-3">
            <label><b>Val. base cálculo multa</b></label>               
            <input type="text" class="form-control" name="percentual" [(ngModel)]="valorBaseCalculoMulta" bnMask="MOEDA" disabled/>
        </div>
        <div class="col-md-3">
            <label><b>Valor percentual multa</b><i class="fa fa-question-circle help-subtitulo" placement="bottom"
                ngbTooltip="O valor percentual de multa a ser cobrado sobre o valor base para multa selecionado. Informar 0,000000 para não cobrar multa."></i>
            </label>     
            <input type="text" class="form-control" name="valorPercentualMulta" [(ngModel)]="valorPercentualMulta" bnMask="DECIMAL" [casasDecimais]="6" />
        </div>
    </div>
    <p class="row">
        <b class="mt-3 col-md-12">
            *Ao aprovar esta solicitação de cancelamento de garantia, será emitido boleto de cobrança para devolução do valor honrado a recuperar.
        </b>
    </p>
</ng-template>

<ng-template #reprovacao>
    <label for="motivoReprovacao"><b>Motivo para reprovação</b></label>
    <textarea class="form-control" id="motivoReprovacao" name="motivoReprovacao" maxlength="200" rows="3" [(ngModel)]="motivoReprovacao" required></textarea>
</ng-template>
<ng-template #reversao>
    <p class="row" *ngIf="modalidadeGarantia === 'PEAC'">
        <b class="mt-3 col-md-12">
            ⚠️ ATENÇÃO: A REVERSÃO DE UMA SOLICITAÇÃO DE CANCELAMENTO DO FGI PEAC QUE FOI REALIZADA ANTES DO INÍCIO DO CICLO DE DISTRIBUIÇÃO DE LIMITES IRÁ GERAR UM AVISO DE INCONSISTÊNCIA NA DISTRIBUIÇÃO DE LIMITES. 
            FAVOR DOCUMENTAR A REALIZAÇÃO DESTA OPERAÇÃO, DE MANEIRA A EVITAR CONTRATEMPOS NO MOMENTO DA CONCLUSÃO DO CICLO CORRENTE DA DISTRIBUIÇÃO DE LIMITES, QUANDO O AVISO DE INCONSISTÊNCIA SERÁ GERADO PARA ESTE AGENTE FINANCEIRO.
        </b>
    </p>
    <label for="motivoReversao"><b>Motivo para reversão do cancelamento</b></label>
    <textarea class="form-control" id="motivoReversao" name="motivoReversao" rows="5" [(ngModel)]="motivoReversao" required></textarea>
</ng-template>
<ng-template #botoesDeAcao>
    <button class="btn btn-default" (click)="cancelarAcao()">Cancelar</button>
    <button class="btn btn-primary" (click)="confirmarAcao()">Confirmar</button>
</ng-template>

<div class="container row" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
        <table class="table-striped table-bordered">
            <thead>
                <tr>
                    <th class="text-center">Erro(s) encontrado(s)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ocorrencia of ocorrencias">
                    <td>{{ ocorrencia.mensagem }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>